import React from 'react';
import Footer from '../components/Footer';

const TermsOfService = () => {
  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <div style={{ flex: 1, padding: '40px 20px', maxWidth: '900px', margin: '0 auto' }}>
        <h1 style={{ marginBottom: '8px', color: '#1a1a2e' }}>Terms of Service</h1>
        <p style={{ color: '#666', marginBottom: '40px' }}>
          Effective Date: March 1, 2025 | Last Updated: January 15, 2026
        </p>

        <div style={{ lineHeight: '1.8', color: '#333' }}>
          <section style={{ marginBottom: '32px' }}>
            <h2 style={{ color: '#1a1a2e', marginBottom: '16px' }}>1. Acceptance of Terms</h2>
            <p>
              By accessing or using ShowingBooker ("Service"), operated by ShowingBooker LLC ("Company,"
              "we," "us," or "our"), you agree to be bound by these Terms of Service. If you do not
              agree to these terms, do not use our Service.
            </p>
          </section>

          <section style={{ marginBottom: '32px' }}>
            <h2 style={{ color: '#1a1a2e', marginBottom: '16px' }}>2. Description of Service</h2>
            <p>
              ShowingBooker is a property showing management platform designed for tenant-occupied
              properties. Our Service provides:
            </p>
            <ul style={{ marginTop: '12px', paddingLeft: '24px' }}>
              <li>Automated scheduling for property showings</li>
              <li>Legal compliance documentation and audit trails</li>
              <li>Tenant notification services (SMS, email, physical mail)</li>
              <li>PDF compliance report generation</li>
              <li>Property management tools for real estate professionals</li>
            </ul>
          </section>

          <section style={{ marginBottom: '32px' }}>
            <h2 style={{ color: '#1a1a2e', marginBottom: '16px' }}>3. Scheduling and Notice Requirements</h2>
            <p>
              All showings must be scheduled at least 24 hours in advance (or as required by
              applicable law) to ensure proper legal notification to all parties. California Civil
              Code Section 1954 requires a minimum 24-hour notice before entering an occupied property.
              ShowingBooker automates compliance with these requirements but users remain responsible
              for ensuring all legal obligations are met.
            </p>
          </section>

          <section style={{ marginBottom: '32px' }}>
            <h2 style={{ color: '#1a1a2e', marginBottom: '16px' }}>4. User Accounts</h2>
            <p>
              To use certain features of the Service, you must create an account. You agree to:
            </p>
            <ul style={{ marginTop: '12px', paddingLeft: '24px' }}>
              <li>Provide accurate and complete information</li>
              <li>Maintain the security of your account credentials</li>
              <li>Promptly update any changes to your information</li>
              <li>Accept responsibility for all activities under your account</li>
              <li>Notify us immediately of any unauthorized access</li>
            </ul>
          </section>

          <section style={{ marginBottom: '32px' }}>
            <h2 style={{ color: '#1a1a2e', marginBottom: '16px' }}>5. Fees and Payment</h2>
            <p>
              <strong>5.1 Platform Fees:</strong> Property tour bookings may be subject to a platform
              fee (currently $10.00) which confirms your private tour time and date. This fee covers
              automated scheduling, legal compliance notifications, and secure payment processing.
            </p>
            <p style={{ marginTop: '12px' }}>
              <strong>5.2 Subscription Plans:</strong> We offer subscription plans for agents and
              property managers. Subscription fees are billed in advance on a monthly basis and
              are non-refundable except as required by law.
            </p>
            <p style={{ marginTop: '12px' }}>
              <strong>5.3 Payment Processing:</strong> All payments are processed securely through
              Stripe. By providing payment information, you authorize us to charge the applicable fees.
            </p>
          </section>

          <section style={{ marginBottom: '32px' }}>
            <h2 style={{ color: '#1a1a2e', marginBottom: '16px' }}>6. Cancellation and Refunds</h2>
            <p>
              Platform fees are non-refundable but bookings can be rescheduled with proper notice
              (minimum 24 hours before scheduled showing). Subscription cancellations take effect
              at the end of the current billing period.
            </p>
          </section>

          <section style={{ marginBottom: '32px' }}>
            <h2 style={{ color: '#1a1a2e', marginBottom: '16px' }}>7. User Responsibilities</h2>
            <p>You agree not to:</p>
            <ul style={{ marginTop: '12px', paddingLeft: '24px' }}>
              <li>Use the Service for any unlawful purpose</li>
              <li>Provide false or misleading information</li>
              <li>Interfere with or disrupt the Service</li>
              <li>Attempt to gain unauthorized access to any part of the Service</li>
              <li>Use the Service to harass, abuse, or harm others</li>
              <li>Violate any applicable local, state, or federal laws</li>
            </ul>
          </section>

          <section style={{ marginBottom: '32px' }}>
            <h2 style={{ color: '#1a1a2e', marginBottom: '16px' }}>8. Compliance Disclaimer</h2>
            <p>
              While ShowingBooker provides tools to help with legal compliance for tenant-occupied
              property showings, we do not provide legal advice. Users are responsible for ensuring
              compliance with all applicable laws and regulations. We recommend consulting with a
              qualified attorney for specific legal questions.
            </p>
          </section>

          <section style={{ marginBottom: '32px' }}>
            <h2 style={{ color: '#1a1a2e', marginBottom: '16px' }}>9. Intellectual Property</h2>
            <p>
              The Service and its original content, features, and functionality are owned by
              ShowingBooker LLC and are protected by copyright, trademark, and other intellectual
              property laws. You may not copy, modify, distribute, or create derivative works
              without our express written permission.
            </p>
          </section>

          <section style={{ marginBottom: '32px' }}>
            <h2 style={{ color: '#1a1a2e', marginBottom: '16px' }}>10. Limitation of Liability</h2>
            <p>
              TO THE MAXIMUM EXTENT PERMITTED BY LAW, SHOWINGBOOKER LLC SHALL NOT BE LIABLE FOR
              ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES, INCLUDING
              BUT NOT LIMITED TO LOSS OF PROFITS, DATA, USE, OR GOODWILL, ARISING OUT OF OR
              RELATED TO YOUR USE OF THE SERVICE.
            </p>
          </section>

          <section style={{ marginBottom: '32px' }}>
            <h2 style={{ color: '#1a1a2e', marginBottom: '16px' }}>11. Indemnification</h2>
            <p>
              You agree to indemnify and hold harmless ShowingBooker LLC and its officers, directors,
              employees, and agents from any claims, damages, losses, or expenses arising from your
              use of the Service or violation of these Terms.
            </p>
          </section>

          <section style={{ marginBottom: '32px' }}>
            <h2 style={{ color: '#1a1a2e', marginBottom: '16px' }}>12. Termination</h2>
            <p>
              We may terminate or suspend your account and access to the Service immediately,
              without prior notice, for conduct that we believe violates these Terms or is harmful
              to other users, us, or third parties, or for any other reason at our sole discretion.
            </p>
          </section>

          <section style={{ marginBottom: '32px' }}>
            <h2 style={{ color: '#1a1a2e', marginBottom: '16px' }}>13. Governing Law</h2>
            <p>
              These Terms shall be governed by and construed in accordance with the laws of the
              State of California, without regard to its conflict of law provisions. Any disputes
              shall be resolved in the courts located in Los Angeles County, California.
            </p>
          </section>

          <section style={{ marginBottom: '32px' }}>
            <h2 style={{ color: '#1a1a2e', marginBottom: '16px' }}>14. Changes to Terms</h2>
            <p>
              We reserve the right to modify these Terms at any time. Changes will be posted on
              this page with an updated "Last Updated" date. Your continued use of the Service
              after changes constitutes acceptance of the modified Terms.
            </p>
          </section>

          <section style={{ marginBottom: '32px', padding: '20px', background: '#f8f9fa', borderRadius: '8px' }}>
            <h2 style={{ color: '#1a1a2e', marginBottom: '16px' }}>Contact Information</h2>
            <p>
              For questions about these Terms of Service:<br /><br />
              <strong>ShowingBooker LLC</strong><br />
              26565 Agoura Road, Suite 200<br />
              Calabasas, CA 91302 USA<br />
              Email: david@codexdeus.com
            </p>
          </section>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default TermsOfService;
